export class FreeTrialCardInput {

    constructor (
        public studentId?: number,
        public cardTypeId?: number) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/free-trial-card-input.model.ts